import type { LearningExercise } from "../types";

// Fachlich gegen BGB geprüft (reviewStatus "reviewed"). Finale beta-ready-Freigabe durch Vincent.
// Karteikarten (kind "flashcard"): Vorderseite = prompt, Rückseite = explanation. Keine Optionen;
// bewertet wird über die Selbsteinschätzung (Grade) im FlashcardCard, die das SR-Intervall steuert.
export const flashcards: LearningExercise[] = [
  {
    id: "hj-card-001",
    pathId: "hagen-jura",
    mode: "ausbildung",
    kind: "flashcard",
    topic: "BGB AT - Geschäftsfähigkeit",
    title: "Beschränkte Geschäftsfähigkeit",
    prompt: "Was bedeutet 'beschränkte Geschäftsfähigkeit' und wen betrifft sie?",
    options: [],
    answers: [],
    explanation:
      "§ 106 BGB: Minderjährige zwischen 7 und 17 Jahren sind beschränkt geschäftsfähig. Ihre Willenserklärungen sind nur wirksam, wenn das Geschäft lediglich rechtlich vorteilhaft ist (§ 107) oder die Eltern einwilligen bzw. genehmigen (§§ 107, 108).",
    sourceIds: ["bgb106"],
    sources: [{ id: "bgb106", label: "§ 106 BGB", url: "https://www.gesetze-im-internet.de/bgb/__106.html" }],
    level: "Bekannt",
    levelNumber: 1,
    errorCategory: "Definition",
    skillTags: ["bgb-at"],
    reviewStatus: "beta-ready",
  },
  {
    id: "hj-card-002",
    pathId: "hagen-jura",
    mode: "ausbildung",
    kind: "flashcard",
    topic: "BGB AT - Willenserklärung",
    title: "Willenserklärung",
    prompt: "Definiere die Willenserklärung und nenne ihre Bestandteile.",
    options: [],
    answers: [],
    explanation:
      "Willenserklärung = private Willensäußerung, die auf das Herbeiführen einer Rechtsfolge gerichtet ist. Objektiver Tatbestand: die nach außen erkennbare Erklärung. Subjektiver Tatbestand: Handlungswille, Erklärungsbewusstsein und Geschäftswille.",
    sourceIds: ["bgb133"],
    sources: [{ id: "bgb133", label: "§ 133 BGB", url: "https://www.gesetze-im-internet.de/bgb/__133.html" }],
    level: "Bekannt",
    levelNumber: 1,
    errorCategory: "Definition",
    skillTags: ["bgb-at"],
    reviewStatus: "beta-ready",
  },
  {
    id: "hj-card-003",
    pathId: "hagen-jura",
    mode: "ausbildung",
    kind: "flashcard",
    topic: "BGB AT - Abstraktionsprinzip",
    title: "Trennungs- und Abstraktionsprinzip",
    prompt: "Erkläre Trennungs- und Abstraktionsprinzip.",
    options: [],
    answers: [],
    explanation:
      "Trennungsprinzip: Verpflichtungsgeschäft (z.B. Kaufvertrag, § 433) und Verfügungsgeschäft (z.B. Übereignung, § 929) sind zu trennen. Abstraktionsprinzip: Beide sind in ihrer Wirksamkeit voneinander unabhängig - der Mangel des einen berührt das andere grundsätzlich nicht.",
    sourceIds: ["bgb929"],
    sources: [{ id: "bgb929", label: "§ 929 BGB", url: "https://www.gesetze-im-internet.de/bgb/__929.html" }],
    level: "Abrufbar",
    levelNumber: 2,
    errorCategory: "Definition",
    skillTags: ["bgb-at"],
    reviewStatus: "beta-ready",
  },
  {
    id: "hj-card-004",
    pathId: "hagen-jura",
    mode: "ausbildung",
    kind: "flashcard",
    topic: "BGB AT - Anfechtung",
    title: "Irrtümer nach § 119 Abs. 1 BGB",
    prompt: "Welche zwei Irrtumsarten regelt § 119 Abs. 1 BGB?",
    options: [],
    answers: [],
    explanation:
      "§ 119 Abs. 1 BGB: Inhaltsirrtum (Var. 1) - der Erklärende irrt über die Bedeutung seiner Erklärung. Erklärungsirrtum (Var. 2) - der Erklärende will eine Erklärung dieses Inhalts gar nicht abgeben (z.B. Versprechen, Vertippen).",
    sourceIds: ["bgb119"],
    sources: [{ id: "bgb119", label: "§ 119 BGB", url: "https://www.gesetze-im-internet.de/bgb/__119.html" }],
    level: "Abrufbar",
    levelNumber: 2,
    errorCategory: "Definition",
    skillTags: ["bgb-at"],
    reviewStatus: "beta-ready",
  },
  {
    id: "hj-card-005",
    pathId: "hagen-jura",
    mode: "ausbildung",
    kind: "flashcard",
    topic: "BGB AT - Anfechtung",
    title: "Rechtsfolge der Anfechtung",
    prompt: "Welche Rechtsfolge hat eine wirksame Anfechtung (§ 142 Abs. 1 BGB)?",
    options: [],
    answers: [],
    explanation:
      "§ 142 Abs. 1 BGB: Das angefochtene Rechtsgeschäft ist als von Anfang an (ex tunc) nichtig anzusehen. Bereits Geleistetes wird über das Bereicherungsrecht (§ 812 BGB) rückabgewickelt.",
    sourceIds: ["bgb142"],
    sources: [{ id: "bgb142", label: "§ 142 BGB", url: "https://www.gesetze-im-internet.de/bgb/__142.html" }],
    level: "Abrufbar",
    levelNumber: 2,
    errorCategory: "Definition",
    skillTags: ["bgb-at"],
    reviewStatus: "beta-ready",
  },
  {
    id: "hj-card-006",
    pathId: "hagen-jura",
    mode: "ausbildung",
    kind: "flashcard",
    topic: "BGB AT - Vertragsschluss",
    title: "Invitatio ad offerendum",
    prompt: "Was ist eine 'invitatio ad offerendum' und wie grenzt sie sich vom Angebot ab?",
    options: [],
    answers: [],
    explanation:
      "Invitatio ad offerendum = bloße Aufforderung zur Abgabe von Angeboten (z.B. Schaufensterauslage, Katalog, Online-Shop). Mangels Rechtsbindungswillen ist sie noch kein Angebot i.S.d. § 145 BGB: Der Kunde gibt das Angebot ab, der Verkäufer nimmt an.",
    sourceIds: ["bgb145"],
    sources: [{ id: "bgb145", label: "§ 145 BGB", url: "https://www.gesetze-im-internet.de/bgb/__145.html" }],
    level: "Abrufbar",
    levelNumber: 2,
    errorCategory: "Definition",
    skillTags: ["bgb-at"],
    reviewStatus: "beta-ready",
  },
];
